export default "__VITE_ASSET__CoL_H1E4__"